'use client';

import { c as _c } from "react/compiler-runtime";
import { BuilderBlocks } from '@builder.io/react';
import { useMemo, useState } from 'react';
import { Text } from '@src/components/Builder/Text/Text';
import { Button } from '@src/components/Button/Button';
import { Container } from '@src/components/Container/Container';
import { CustomerReviewCard } from '@src/components/CustomerReviews/CustomerReviewCard';
import { CustomerReviewsDefaults } from '@src/components/CustomerReviews/CustomerReviews.defaults';
import { type CustomerReviewItem, type CustomerReviewsProps } from '@src/components/CustomerReviews/CustomerReviews.props';
import { StarRating } from '@src/components/CustomerReviews/StarRating';
import { useBreakpoints } from '@src/utils/breakpoints.util';
export const CustomerReviews = t0 => {
  const $ = _c(78);
  const props = t0 === undefined ? CustomerReviewsDefaults : t0;
  const {
    accentColor,
    blocksBottom,
    builderBlock,
    gradientColor,
    heading,
    items: t1,
    loadMoreText,
    subheading,
    subHeadingRatingOutOfFive
  } = props;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const items = t2;
  const [sliceIncrement, setSliceIncrement] = useState(0);
  const breakpoints = useBreakpoints();
  const isMobile = breakpoints.isMobile || breakpoints.isTablet;
  let t3;
  bb0: {
    if (!isMobile) {
      let t4;
      if ($[2] !== items || $[3] !== sliceIncrement) {
        t4 = items.filter(_temp).slice(0, 2 + sliceIncrement);
        $[2] = items;
        $[3] = sliceIncrement;
        $[4] = t4;
      } else {
        t4 = $[4];
      }
      const first = t4;
      let t5;
      if ($[5] !== items || $[6] !== sliceIncrement) {
        t5 = items.filter(_temp2).slice(0, 2 + sliceIncrement);
        $[5] = items;
        $[6] = sliceIncrement;
        $[7] = t5;
      } else {
        t5 = $[7];
      }
      const second = t5;
      let t6;
      if ($[8] !== items || $[9] !== sliceIncrement) {
        t6 = items.filter(_temp3).slice(0, 2 + sliceIncrement);
        $[8] = items;
        $[9] = sliceIncrement;
        $[10] = t6;
      } else {
        t6 = $[10];
      }
      const third = t6;
      let t7;
      if ($[11] !== first || $[12] !== second || $[13] !== third) {
        t7 = {
          first,
          second,
          third
        };
        $[11] = first;
        $[12] = second;
        $[13] = third;
        $[14] = t7;
      } else {
        t7 = $[14];
      }
      t3 = t7;
      break bb0;
    }
    let t4;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = [];
      $[15] = t4;
    } else {
      t4 = $[15];
    }
    const first_0 = t4 as CustomerReviewItem[];
    let t5;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = [];
      $[16] = t5;
    } else {
      t5 = $[16];
    }
    const second_0 = t5 as CustomerReviewItem[];
    let t6;
    if ($[17] !== items || $[18] !== sliceIncrement) {
      t6 = items.slice(0, 3 + sliceIncrement * 3);
      $[17] = items;
      $[18] = sliceIncrement;
      $[19] = t6;
    } else {
      t6 = $[19];
    }
    const third_0 = t6;
    let t7;
    if ($[20] !== third_0) {
      t7 = {
        first: first_0,
        second: second_0,
        third: third_0
      };
      $[20] = third_0;
      $[21] = t7;
    } else {
      t7 = $[21];
    }
    t3 = t7;
  }
  const columns = t3;
  const hasMore = items.length > columns?.first?.length + columns?.second?.length + columns?.third?.length;
  let t4;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setSliceIncrement(_temp4);
    };
    $[22] = t4;
  } else {
    t4 = $[22];
  }
  const onLoadMoreClick = t4;
  let T0;
  let t10;
  let t11;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[23] !== accentColor || $[24] !== columns?.first || $[25] !== columns?.second || $[26] !== columns?.third || $[27] !== gradientColor || $[28] !== heading || $[29] !== sliceIncrement || $[30] !== subHeadingRatingOutOfFive || $[31] !== subheading) {
    const renderColumns = () => {
      const first_1 = columns?.first;
      const second_1 = columns?.second;
      const third_1 = columns?.third;
      return <>{first_1?.length > 0 && <div className="grid gap-4 lg:gap-10">{first_1.map(renderCard)}</div>}{second_1?.length > 0 && <div className="grid gap-4 lg:gap-10">{second_1.map(renderCard)}</div>}{third_1?.length > 0 && <div className="grid gap-4 lg:gap-10">{third_1.map(renderCard)}</div>}</>;
    };
    const renderCard = (item, i_2) => <CustomerReviewCard color={accentColor} content={item.content} key={i_2} name={item.name} product={item.product} ratingOutOfFive={item.ratingOutOfFive} shouldAnimate={sliceIncrement > 0} />;
    t10 = "relative bg-white py-28";
    const t12 = `radial-gradient(at center, ${gradientColor} 0%, transparent 80%)`;
    if ($[40] !== t12) {
      t11 = {
        backgroundImage: t12
      };
      $[40] = t12;
      $[41] = t11;
    } else {
      t11 = $[41];
    }
    T0 = Container;
    t7 = "bg-transparent";
    if ($[42] !== heading) {
      t8 = <h2 className="text-heading-display-2 relative mb-1 text-center text-bodi-black-text">{heading}</h2>;
      $[42] = heading;
      $[43] = t8;
    } else {
      t8 = $[43];
    }
    const t13 = subHeadingRatingOutOfFive ?? 0;
    let t14;
    if ($[44] !== accentColor || $[45] !== t13) {
      t14 = <StarRating color={accentColor} ratingOutOfFive={t13} />;
      $[44] = accentColor;
      $[45] = t13;
      $[46] = t14;
    } else {
      t14 = $[46];
    }
    const t15 = subheading ?? "";
    let t16;
    if ($[47] !== t15) {
      t16 = {
        __html: t15
      };
      $[47] = t15;
      $[48] = t16;
    } else {
      t16 = $[48];
    }
    let t17;
    if ($[49] !== accentColor) {
      t17 = {
        color: accentColor
      };
      $[49] = accentColor;
      $[50] = t17;
    } else {
      t17 = $[50];
    }
    let t18;
    if ($[51] !== t16 || $[52] !== t17) {
      t18 = <div dangerouslySetInnerHTML={t16} style={t17} />;
      $[51] = t16;
      $[52] = t17;
      $[53] = t18;
    } else {
      t18 = $[53];
    }
    if ($[54] !== t14 || $[55] !== t18) {
      t9 = <div className="relative mb-6 flex items-center justify-center gap-2">{t14}{t18}</div>;
      $[54] = t14;
      $[55] = t18;
      $[56] = t9;
    } else {
      t9 = $[56];
    }
    t5 = "\n          grid items-start lg:grid-cols-3 lg:gap-10";
    t6 = renderColumns();
    $[23] = accentColor;
    $[24] = columns?.first;
    $[25] = columns?.second;
    $[26] = columns?.third;
    $[27] = gradientColor;
    $[28] = heading;
    $[29] = sliceIncrement;
    $[30] = subHeadingRatingOutOfFive;
    $[31] = subheading;
    $[32] = T0;
    $[33] = t10;
    $[34] = t11;
    $[35] = t5;
    $[36] = t6;
    $[37] = t7;
    $[38] = t8;
    $[39] = t9;
  } else {
    T0 = $[32];
    t10 = $[33];
    t11 = $[34];
    t5 = $[35];
    t6 = $[36];
    t7 = $[37];
    t8 = $[38];
    t9 = $[39];
  }
  let t12;
  if ($[57] !== t5 || $[58] !== t6) {
    t12 = <div className={t5}>{t6}</div>;
    $[57] = t5;
    $[58] = t6;
    $[59] = t12;
  } else {
    t12 = $[59];
  }
  const t13 = builderBlock?.id;
  let t14;
  if ($[60] !== blocksBottom || $[61] !== t13) {
    t14 = <div className="relative mt-8 mb-6 lg:mt-16"><BuilderBlocks parentElementId={t13} dataPath="component.options.contentBottom" blocks={blocksBottom} /></div>;
    $[60] = blocksBottom;
    $[61] = t13;
    $[62] = t14;
  } else {
    t14 = $[62];
  }
  let t15;
  if ($[63] !== hasMore || $[64] !== loadMoreText) {
    t15 = hasMore && <Button className="mx-auto block" size="medium" variant="secondary" onClick={onLoadMoreClick}><Text style="Body Base" text={loadMoreText ?? ""} /></Button>;
    $[63] = hasMore;
    $[64] = loadMoreText;
    $[65] = t15;
  } else {
    t15 = $[65];
  }
  let t16;
  if ($[66] !== T0 || $[67] !== t12 || $[68] !== t14 || $[69] !== t15 || $[70] !== t7 || $[71] !== t8 || $[72] !== t9) {
    t16 = <T0 className={t7}>{t8}{t9}{t12}{t14}{t15}</T0>;
    $[66] = T0;
    $[67] = t12;
    $[68] = t14;
    $[69] = t15;
    $[70] = t7;
    $[71] = t8;
    $[72] = t9;
    $[73] = t16;
  } else {
    t16 = $[73];
  }
  let t17;
  if ($[74] !== t10 || $[75] !== t11 || $[76] !== t16) {
    t17 = <div className={t10} style={t11}>{t16}</div>;
    $[74] = t10;
    $[75] = t11;
    $[76] = t16;
    $[77] = t17;
  } else {
    t17 = $[77];
  }
  return t17;
};
function _temp(_, i) {
  return i % 3 === 0;
}
function _temp2(__0, i_0) {
  return i_0 % 3 === 1;
}
function _temp3(__1, i_1) {
  return i_1 % 3 === 2;
}
function _temp4(current) {
  return current + 1;
}